webpackJsonp([18],{

/***/ "29pa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_register_service_worker__ = __webpack_require__("ydGU");
/* eslint-disable no-console */



/* if (process.env.NODE_ENV === 'production') { */
Object(__WEBPACK_IMPORTED_MODULE_0_register_service_worker__["a" /* register */])('/static/serviceworker.js', {
  ready: function ready() {
    console.log('App is being served from cache by a service worker.\n' + 'For more details, visit https://goo.gl/AFskqB');
  },
  registered: function registered() {
    console.log('SW Service worker has been registered.');
  },
  cached: function cached() {
    console.log('SW Content has been cached for offline use.');
  },
  updatefound: function updatefound() {
    console.log('SW New content is downloading.');
  },
  updated: function updated() {
    console.log('SW New content is available; please refresh.');
  },
  offline: function offline() {
    console.log('SW No internet connection found. App is running in offline mode.');
  },
  error: function error(_error) {
    console.error('SW Error during service worker registration:', _error);
  }
});
/* } */

/***/ }),

/***/ "6NMK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__ = __webpack_require__("89vL");







var db = __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].database();

// This is your plugin object. It can be exported to be used anywhere.
var SlinkPlugins = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install: function install(Vue, options) {
    // We call Vue.mixin() here to inject functionality into all components.
    Vue.mixin({
      // Anything added to a mixin will be injected into all components.
      // In this case, the mounted() method runs when the component is added to the DOM.
      mounted: function mounted() {
        //   console.log('Mounted!');
      },
      data: function data() {
        return {
          iceLocation: null,
          loadingStatus: false,
          // dynamicMediaHeight:{'height':'0px', 'padding-top':'20px' },
          urlExists: false,
          notification: null,
          // gFetchedFavicon: null,
          gCustomSiteFavicon: null,
          isMobile: navigator.share,
          rowLabel: null,
          rowValue: null,
          slinkCanInLine: [
          // "QR Code",
          "Link Grid", "Carousel", "Rumble Player", "In-Line Text Block", "Gallery", "Castbox Player", "Mixer Player", "YouTube Player", "Vimeo Player", "SoundCloud Player", "MixCloud Player", "Spotify Player", "Text Block", "Embed", "Twitch Player", "Audio Player", "Video Player", "Apple Music Player", "Image", "Personal Statistics", "List", "Link Group", 'TikTok Player', 'Instagram Post', 'Ko-fi Donation', 'Opensea Embed', 'Gumroad Product', "Tweet", "Whisper Box"],
          arDimensions: {
            'YouTube Player': '16/9',
            'Instagram Post': '353.6/600',
            'TikTok Player': '346/710'

          },
          gSiteTemplate: {
            background: "white",
            base: "",
            color: "black",
            customsite: "",
            fa: "link",
            favicon: "",
            placeholder: "URL",
            site: "",
            standard: false,
            faviconFull: "0",
            adult: false,
            premium: false,
            mailchimp: false,
            suffix: "",
            scratch: null
          },
          activeChild: null,

          // gTravel
          travelTo: null,

          //gCreateCustomSite
          customNewSite: null
        };
      },

      computed: {
        groupSize: function groupSize() {
          return _.size(this.getGroups) > 0 ? true : false;
        },

        getGroups: function getGroups() {
          return this.slinks ? this.slinks.filter(function (slink) {
            return slink.site === 'Link Group' || slink.site === 'Link Grid';
          }).sort(function (a, b) {
            return a.order - b.order;
          }) : [];
        },

        messageCount: function messageCount() {
          return this.profile && this.profile.messages != undefined ? _.size(this.profile.messages) - 1 : 0;
        },

        cardCount: function cardCount() {
          // updated
          return this.userDetails.cards ? _.size(this.userDetails.cards) : 0;
        },
        quicklinks: function quicklinks() {
          return this.profile ? this.slinks.filter(function (slink) {
            return slink.quicklink === true && slink.disabled !== true;
          }) : null;
        },


        getSensitiveUserPicture: function getSensitiveUserPicture() {
          try {
            if (this.userDetails.picture) {
              // console.log('sensitive content', this.userDetails.picture)
              return this.userDetails.picture.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o', 'https://ik.imagekit.io/slink/tr:n-sensitiveContent');
            } else {
              return "https://ui-avatars.com/api/?color=fff&background=3f51b5&size=128&name=" + this.userDetails.name.substring(0, 1);
            }
          } catch (err) {}
        },

        getUserPicture: function getUserPicture() {
          //updated 2020-11-20
          var picture = this.picture,
              userDetails = this.userDetails;


          console.log(picture);
          if (picture) {
            var imageKit = picture;
            if (userDetails.pictureSize) {
              // imageKit = imageKit.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-profilepicture')
              // imageKit = imageKit.replace('https://cdn.myslink.app','https://ik.imagekit.io/slink/tr:n-profilepicture')
            } else if (userDetails.pictureAdult) {
              imageKit = imageKit.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o', 'https://ik.imagekit.io/slink/tr:n-blur');
              imageKit = imageKit.replace('https://cdn.myslink.app', 'https://ik.imagekit.io/slink/tr:n-blur');
            }
            return imageKit;
          }
          return (
            // "/static/images/avatar.jpg"
            picture
          );
        },
        // getHeaderBackground: function() { //reduntant  2020-11-20
        //   try{
        //     return "background: " + this.userDetails.background;
        //   }
        //   catch(err){
        //   }
        // },
        getCustomFont: function getCustomFont() {
          if (this.profile && (this.customFont != null || this.userDetails && this.userDetails.customFont)) {
            var customFont = this.userDetails.customFont.replace(/:wght@\d*/g, '').replace(/\+/g, ' ');
            customFont = customFont.split(":");
            customFont = customFont[0];
            // console.log(this.customFont, customFont)

            return { 'font-family': customFont + ', sans-serif' }; // Fallback font added
          } else if (this.profile && (this.customHostedFont != null || this.userDetails && this.userDetails.customHostedFont)) {
            return { 'font-family': 'hostedFont, sans-serif' }; // Fallback font added
          }

          return {};
        },
        getAdminCustomFont: function getAdminCustomFont() {
          // console.log('getAdminCustomFont',this.userDetails.customFont)
          return this.profile ? this.userDetails.customFont : null;
        },

        getBackground: function getBackground() {
          console.log('getBackground', this.profile);
          if (!this.profile) return 'default_background_style'; // Replace with your default background style
          var filterMapping = {
            dark: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), ',
            medium: 'linear-gradient(rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.25)), ',
            light: 'linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), '
          };
          if (this.profile.backgroundImage && (this.profile.account === 7 || this.profile.enableUpgrades)) {
            var backgroundImage = "url(\"" + this.userContentCDN(this.profile.backgroundImage) + "\")";
            if (this.profile.backgroundFilter && this.profile.backgroundFilter !== 'none') {
              backgroundImage = filterMapping[this.profile.backgroundFilter] + backgroundImage;
            }
            console.log('backgroundImage', backgroundImage);
            return backgroundImage;
          }
          this.profile.background2 = this.profile.background2 || "#ffffff";
          if (this.customFont) {
            return "font-family: " + this.userDetails.customFont + ", cursive; background: linear-gradient(180deg, " + this.profile.background + " 0%, " + this.profile.background2 + " 100%)";
          }
          return "linear-gradient(180deg, " + this.profile.background + " 0%, " + this.profile.background2 + " 100%)";
        },


        getAvatarBackground: function getAvatarBackground() {
          try {
            return this.userDetails.account == 7 ? "3px solid " + this.userDetails.background : null;
          } catch (err) {}
        },
        borderRadius: function borderRadius() {
          try {
            return (
              // this.userDetails.account == 7 ||
              // this.userDetails.enableUpgrades) &&
              // this.userDetails.rounded &&
              !this.userDetails.fullScreen ? "20px" : "0px"
            );
          } catch (err) {}
        },
        // fullScreenPadding: function() {
        //   try{
        //     return this.userDetails.fullScreen ? "0px" : "20px";
        //   }
        //   catch(err){}
        // }
        fullScreenPadding: function fullScreenPadding() {
          //updated 2020-11-20
          return this.userDetails && this.userDetails.fullScreen ? "0px" : "20px";
        }
      },
      methods: {
        // getPageBackground() {
        //   console.log('runnin improved getPageBackground')
        //   try {
        //     let bg = {};
        //     if (this.profile.backgroundImage !== undefined && (this.userDetails.account === 7 || this.userDetails.enableUpgrades)) {
        //       bg.backgroundImage = `url("${this.userContentCDN(this.userDetails.backgroundImage)}")`;

        //       const filterMapping = {
        //         dark: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), ',
        //         medium: 'linear-gradient(rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.25)), ',
        //         light: 'linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), '
        //       };

        //       if (this.userDetails.backgroundFilter && this.userDetails.backgroundFilter !== 'none') {
        //         bg.backgroundImage = filterMapping[this.userDetails.backgroundFilter] + bg.backgroundImage;
        //       }
        //       return bg;
        //     } else {
        //       if (!this.userDetails.background2) {
        //         this.userDetails.background2 = "#ffffff";
        //       }
        //       if (this.customFont) {
        //         bg['font-family'] = `${this.userDetails.customFont}, cursive;`;
        //       }
        //       const backgroundStyle = `background: linear-gradient(180deg, ${this.userDetails.background} 0%, ${this.userDetails.background2} 100%);`;
        //       return backgroundStyle;
        //     }
        //   } catch (err) {
        //     console.log('getBackground error', err);
        //   }
        // },

        // getPageBackground1: function(bgImage, bgFilter, bg1, bg2, account) {
        //   try{
        //     let self = this
        //     let bg = {};
        //     if(this.profile.backgroundImage != undefined &&(this.userDetails.account == 7 || this.userDetails.enableUpgrades)){
        //       bg.backgroundImage = 'url("'+this.userContentCDN(this.userDetails.backgroundImage) +'")'
        //       if(this.userDetails.backgroundFilter == null || this.userDetails.backgroundFilter == 'none'){

        //       }
        //       else if(this.userDetails.backgroundFilter == 'dark'){
        //         bg.backgroundImage = 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), '+ bg.backgroundImage
        //       }
        //       else if(this.userDetails.backgroundFilter == 'medium'){
        //         bg.backgroundImage = 'linear-gradient(rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.25)), '+ bg.backgroundImage
        //       }
        //       else if(this.userDetails.backgroundFilter == 'light'){
        //         bg.backgroundImage = 'linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), '+ bg.backgroundImage
        //       }
        //       return bg
        //     }
        //     else {
        //       let bg = {};
        //       if (this.userDetails.background2 == null || this.userDetails.background2 == undefined) {
        //         this.userDetails.background2 = "#ffffff";
        //       }
        //       let customFont = ''
        //       if(this.customFont != null){
        //         customFont = "font-family:"+ this.userDetails.customFont +", cursive;"
        //         bg['font-family'] = this.userDetails.customFont +", cursive;"
        //       }
        //       let b = "background: linear-gradient(180deg, "+this.userDetails.background +" 0%, " + this.userDetails.background2 + " 100%);"
        //       return (b);
        //     }
        //   }
        //   catch(err){
        //     console.log('getBackground error', err)
        //   }
        // },
        scheduleLink: function scheduleLink(linkid, event, date, user) {
          db.ref('users/' + user + '/links/' + linkid + '/' + event).transaction(function () {
            return date;
          });
        },
        resetLinkScheduleDate: function resetLinkScheduleDate(linkid, event, date, index) {
          this.slinks[index][event] = '';
          db.ref('users/' + this.activeUID + '/links/' + linkid + '/' + event).fbdb.transaction(function () {
            return '';
          });
        },
        slinkURLExists: function slinkURLExists(url) {
          var _this = this;

          // console.log('looking for', url)
          this.$bindAsArray("_urlExists", db.ref("url/").orderByChild("url").equalTo(url.toLowerCase()), null, function () {
            // console.log('matches found ####', this._urlExists.length)
            if (_this._urlExists == 0) {
              // console.log('nothing found')
              // this.urlExists = false
              return false;
            } else {
              // console.log('found a match')
              // this.tempSettings.url = this.userDetails.url
              // if (this.updateSettings == null) {
              //   this.updateSettings = {};
              // }
              // this.updateSettings['url'] = this.userDetails.url;
              _this.urlExists = true;
              _this.showNotification("This URL is already taken!");
              // console.log('url reset', this.userDetails.url, this.tempSettings.url)
              return true;
            }

            return _this.urlExists;
          });
        },
        userContentCDN: function userContentCDN(path) {
          if (path.indexOf("firebasestorage.googleapis.com") != -1) {
            path = path.replace("firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o", "cdn.myslink.app");
            // path = path.replace("firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o", "ik.imagekit.io/slink/")
          }
          return path;
        },
        getDate: function getDate(timestamp) {
          var date = new Date(parseInt(timestamp));
          var formattedDate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
          return formattedDate;
        },
        getGroup: function getGroup(link) {
          var groupedLink = this.slinks.filter(function (s) {
            return s.id == link;
          });
          return groupedLink[0].group;
        },

        inGroup: function inGroup(group, usage) {
          //updated
          var filteredLinks = this.slinks.filter(function (s) {
            if (usage) {
              return s.group === group;
            } else {
              return s.group === group && s.disabled !== true;
            }
          });
          if (this.userDetails.alphabetical) {
            return _.orderBy(filteredLinks, ["site"], ["asc"]);
          } else {
            return _.orderBy(filteredLinks, "order");
          }
        },


        getProfile: function getProfile() {
          // console.log('gettingAltProfile', this.userDetails.altProfile)

          // console.log('getProfile', this.userDetails.account)
          if (this.userDetails.account < 6) {}
          // console.log('getProfile', 'account not upgraded')

          // console.log('getProfile', 'enableUpgrades',this.userDetails.enableUpgrades )

          if (this.userDetails.enableUpgrades == true) {}
          // console.log('getProfile', 'enableUpgrades',this.userDetails.enableUpgrades )


          // if((this.userDetails.altProfile == 1 || this.userDetails.altProfile == 6 || this.userDetails.altProfile == 8) && (this.userDetails.account < 6 && this.userDetails.enableUpgrades == false)){
          // if((this.userDetails.altProfile == 1 || this.userDetails.altProfile == 6 || this.userDetails.altProfile == 8) && (this.userDetails.account < 6 && !this.userDetails.enableUpgrades)){
          // console.log('getProfile', this.userDetails.account, this.userDetails.altProfile)
          // return 0
          // }
          if ((this.userDetails.altProfile == 18 || this.userDetails.altProfile == 19 || this.userDetails.altProfile == 11 || this.userDetails.altProfile == 3 || this.userDetails.altProfile == 2 || this.userDetails.altProfile == 9 || this.userDetails.altProfile == 4 || this.userDetails.altProfile == 7 || this.userDetails.altProfile == 10 || this.userDetails.altProfile == 13) && this.userDetails.account < 7 && this.userDetails.enableUpgrades == false) {
            //  console.log('gettingAltProfile', this.userDetails.altProfile)
            return 0;
          }
          // )
          // else if(this.userDetails.account != 7 && !this.userDetails.enableUpgrades){
          //   return 0
          // }
          else {
              if (this.withCard == false || this.userDetails.altProfileCard == undefined) {
                return this.userDetails.altProfile;
              } else {
                return this.userDetails.altProfileCard;
              }
            }
        },
        errorImage: function errorImage(site) {
          // console.log('Link', site, 'failaed to load icon')
          this.link.favicon = '../static/images/favicons/initial/' + site.slice(0, 1).toLowerCase() + '.png';
          this.link.faviconFull = true;
        },
        getLinkExample: function getLinkExample(example) {
          if (example == null || example == undefined) {
            return '';
          } else {
            return 'eg ' + example;
          }
        },
        setScratch: function setScratch(event) {
          this.scratch = event.target.value;
        },

        // updateUserProperty1(event){
        //   // console.log('updating property', event.target.name)
        //   let newValue = event.target.value
        //   let prop = event.target.name
        //   let self = this
        //   if (this.scratch != newValue){
        //     this.fbdb = db.ref('users/'+ this.targetUser + '/' + prop).transaction(function () {
        //       return newValue
        //     }).then( function(){
        //       self.showNotification(prop + " updated!");
        //     })
        //   }
        //   if (prop == "url"){
        //     this.fbdb = db.ref('url/'+ this.targetUser + '/' + prop).transaction(function () {
        //       return newValue
        //     })
        //   }
        //   this.scratch = null
        // },
        updateUserProperty: function updateUserProperty(event) {
          //updated
          var newValue = event.target.value;
          var prop = event.target.name;
          var self = this;
          if (this.scratch !== newValue) {
            db.ref("users/" + this.targetUser + "/" + prop).transaction(function () {
              return newValue;
            }).then(function () {
              self.showNotification(prop + " updated!");
            });
            if (prop === "url") {
              db.ref("url/" + this.targetUser + "/" + prop).transaction(function () {
                return newValue;
              });
            }
          }
          this.scratch = null;
        },


        // updateLinkProperty(linkid, property, value){
        //   this.fbdb = db.ref('users/'+ this.activeUID + '/links/' + linkid +'/'+property).transaction(function () {
        //     return value
        //   }).then( function(){
        //     // self.showNotification("Slink updated!");
        //   })
        // },
        updateLinkProperty: function updateLinkProperty(linkid, property, value) {
          //updated
          console.log(linkid, property, value);
          db.ref("users/" + this.activeUID + "/links/" + linkid + "/" + property).transaction(function () {
            return value;
          });
        },
        updateGroup: function updateGroup(linkid, groupid, groupOrder) {
          // console.log('updating group')
          this.fbdb = db.ref('users/' + this.activeUID + '/links/' + linkid + '/group').transaction(function () {
            return groupid;
          }).then(function () {
            // self.showNotification("Slink updated!");
          });
        },

        // updateSlinkDetails(event){
        //   // console.log('#####', event)
        //   let newValue = event.target.value.trim()
        //   let prop = event.target.name
        //   let slink = event.target.id
        //   let site = event.target.alt

        //   if(prop == 'background'){
        //     this.activeEditLink.background = newValue
        //   }

        //   if (this.scratch !== newValue) {
        //     db.ref(`users/${this.activeUID}/links/${slink}/${prop}`)
        //       .transaction(() => newValue)
        //       .then(() => {
        //         this.showNotification("Slink updated!");
        //       });
        //     this.scratch = null;
        //     this.gGALog(this.userDetails.url, 'Update Slink', `${site}: ${prop}`);
        //   }
        // }, 
        updateSlinkDetails: function updateSlinkDetails(event) {
          var _this2 = this;

          // updated
          console.log(event);
          var newValue = event.target.value.trim();
          var prop = event.target.name;
          var slink = event.target.id;
          var site = event.target.alt;
          if (prop === 'background') {
            this.activeEditLink.background = newValue;
          }

          if (this.scratch !== newValue) {
            db.ref("users/" + this.activeUID + "/links/" + slink + "/" + prop).transaction(function () {
              return newValue;
            }).then(function () {
              _this2.showNotification("Slink updated!");
              _this2.scratch = null;
              _this2.gGALog(_this2.userDetails.url, 'Update Slink', site + ": " + prop);
            });
          }
        },
        reorder: function reorder(event) {
          var _this3 = this;

          //updated
          this.slinks.forEach(function (slink, index) {
            var updatedOrder = index;
            db.ref("users/" + _this3.activeUID + "/links/" + slink.id).update({ order: updatedOrder });
          });
          this.gGALog(this.userDetails.url, 'Re-Ordered', event.moved.element.site);
        },
        superReorder: function superReorder(event) {
          var movedLink = event.moved.element.id;
          var oldIndex = event.moved.oldIndex;
          var newIndex = event.moved.newIndex;
          var changes = [];
          for (var i in this.slinks) {
            changes[i] = { 'key': this.slinks[i].id, 'order': i };
          }
          for (var c in changes) {
            this.fbdb = db.ref('users/' + this.targetUser + '/links/' + changes[c].key).update({ order: parseInt(changes[c].order) });
          }
          this.gGALog(this.userDetails.url, 'Re-Ordered', event.moved.element.site);
        },
        addListRow: function addListRow(label, value) {
          var newRow = { 'value': value
            // console.log(newRow)
            // console.log('#',this.newSlinkSite.template,'#')
            // this.newSlinkSite.template[label] = {'value':value}
          };this.newSlinkSite.template[label] = value;
          // this.newSlinkSite.template[label]
          // if( this.newSlinkSite.template == ''){
          //   this.newSlinkSite.template = []
          // // console.log('array',this.newSlinkSite.template,'#')
          // // this.newSlinkSite.template[label] = {'value':value}


          // this.newSlinkSite.template.push({[label]:newRow})
          // // this.newSlinkSite.template = {[label]:newRow}
          // console.log(this.newSlinkSite.template)
          // }
          // else{
          //   this.newSlinkSite.template[label].value = value
          // }
        },

        gOpenDialog: function gOpenDialog(ref) {
          this.$refs[ref].open();
        },
        gCloseDialog: function gCloseDialog(ref) {
          this.$refs[ref].close();
        },
        gCancelSub: function gCancelSub(uid, subid) {
          // console.log('Closed', type);
          // this.gCloseDialog('cancelSubDialog')
          var self = this;
          this.fbdb = db.ref('users/' + uid + '/stripeCancel').transaction(function () {
            return subid;
          }).then(function () {
            // console.log('has been downgraded to a Free account')
            self.gGALog(self.userDetails.url, "Billing", "Subscription Cancelled");
            this.fbdb = db.ref('users/' + i + '/messages/').push({ message: 'Processing subscription cancellation.' });
            self.showNotification("Subscription cancellation in progress!");
          });
        },
        deleteMessage: function deleteMessage(uid, messageid) {
          db.ref("/users/" + uid + "/messages/" + messageid).remove();
          this.gGALog(this.userDetails.url, "Messages", "Deleted");
          if (this.userDetails.messages.length == 1) {
            db.ref("/users/" + uid + "/messages/").update({ unread: false });
          }
        },
        imageKit: function imageKit(url, usage, ignore) {
          // if statements for different image types, normal, gallery thumbnail, icon

          // https://storage.googleapis.com/download/storage/v1/b/slink-64a53.appspot.com/o/userContent%2FYYZKhL3N2SfE2zRwOwCDoIlqDSp2%2Fprofile?generation=1666049636405117&alt=media
          // let transformation = null
          var imageKitURL = url;

          imageKitURL = imageKitURL.replace('https://storage.googleapis.com/download/storage/v1/b/slink-64a53.appspot.com/o', 'https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o');
          if (ignore == true) {
            return url;
          } else {
            if (usage == 'adminThumbnail') {
              imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o', 'https://ik.imagekit.io/slink/tr:n-admin_preview');
            } else if (usage == 'vcf') {
              imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o', 'https://ik.imagekit.io/slink/tr:n-vcf');
            } else if (usage == 'profilepicture') {
              imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o', 'https://ik.imagekit.io/slink/tr:n-profilepicture');
            } else if (usage == 'favicon') {
              imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o', 'https://ik.imagekit.io/slink/tr:n-favicon');
            } else if (usage == '9cube') {
              imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o', 'https://ik.imagekit.io/slink/tr:n-9cube');
            } else if (usage == '9cubethumb') {
              imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o', 'https://ik.imagekit.io/slink/tr:n-media_library_thumbnail  ');
            }
            imageKitURL = imageKitURL.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o', 'https://ik.imagekit.io/slink/tr:w-' + window.screen.width + ',q:75');
            imageKitURL = imageKitURL.replace('https://source.unsplash.com', 'https://ik.imagekit.io/slink/slinkunsplash/tr:n-media_library_thumbnail');
            return imageKitURL;
            // return imageKitURL
          }
        },
        companyLogoUpload: function companyLogoUpload(event, uid) {
          var updatePic = event[0];
          var extension = updatePic.name.substring(updatePic.name.indexOf("."));
          // console.log(updatePic.name, extension)
          this.loadingStatus = true;
          var self = this;
          var uploadTask = __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].storage().ref('userContent/' + uid + '/companyLogo').put(updatePic);
          uploadTask.on('state_changed', function (snapshot) {
            var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
            // console.log('Upload is ' + progress + '% done');
            self.loadingPicProgress = progress;
            // console.log('progres', progress)
          }, function (error) {
            console.log(error);
          }, function () {
            uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              var profilefbdb = db.ref('users/' + uid + '/business/companyLogo');
              profilefbdb.transaction(function () {
                return downloadURL;
              }).then(function () {
                // self.gGALog(self.userDetails.url, "Profile updated", 'picture');
                self.loadingStatus = false;
                // self.tempSettings.picture = downloadURL
                // self.loadingPicProgress = null
              });
            });
          });
        },
        pictureUpload: function pictureUpload(event, uid) {
          var _this4 = this;

          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
            var updatePic, self, originalSizeKB, processedBlob, processedSizeKB, savingsPercentage, uploadTask;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    updatePic = event[0];

                    _this4.loadingStatus = true;
                    self = _this4;

                    // Log original file size

                    originalSizeKB = (updatePic.size / 1024).toFixed(2);

                    console.log("Original image size: " + originalSizeKB + " KB");

                    _context.prev = 5;
                    _context.next = 8;
                    return _this4.resizeAndConvertToWebP(updatePic, 750);

                  case 8:
                    processedBlob = _context.sent;


                    // Log processed file size and savings
                    processedSizeKB = (processedBlob.size / 1024).toFixed(2);
                    savingsPercentage = ((updatePic.size - processedBlob.size) / updatePic.size * 100).toFixed(1);

                    console.log("Processed image size: " + processedSizeKB + " KB");
                    console.log("Storage savings: " + savingsPercentage + "% (" + (originalSizeKB - processedSizeKB).toFixed(2) + " KB saved)");

                    // Upload the processed WebP file
                    uploadTask = __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].storage().ref('userContent/' + uid + '/profile.webp').put(processedBlob);

                    uploadTask.on('state_changed', function (snapshot) {
                      var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                      self.loadingPicProgress = progress;
                    }, function (error) {
                      console.log(error);
                      self.loadingStatus = false;
                    }, function () {
                      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                        var profilefbdb = db.ref('users/' + uid + '/picture');
                        profilefbdb.transaction(function () {
                          return downloadURL;
                        }).then(function () {
                          self.gGALog(self.userDetails.url, "Profile updated", 'picture');
                          self.loadingStatus = false;
                          self.tempSettings.picture = downloadURL;
                        });
                      });
                    });
                    _context.next = 22;
                    break;

                  case 17:
                    _context.prev = 17;
                    _context.t0 = _context["catch"](5);

                    console.error('Error processing image:', _context.t0);
                    self.loadingStatus = false;
                    self.showNotification('Error processing image. Please try again.');

                  case 22:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this4, [[5, 17]]);
          }))();
        },
        resizeAndConvertToWebP: function resizeAndConvertToWebP(file) {
          var maxWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

          return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var img = new Image();

            img.onload = function () {
              // Calculate new dimensions maintaining aspect ratio
              var width = img.width,
                  height = img.height;

              if (width > maxWidth) {
                height = height * maxWidth / width;
                width = maxWidth;
              }

              // Set canvas dimensions
              canvas.width = width;
              canvas.height = height;

              // Draw and resize image
              ctx.drawImage(img, 0, 0, width, height);

              // Convert to WebP blob
              canvas.toBlob(function (blob) {
                if (blob) {
                  resolve(blob);
                } else {
                  reject(new Error('Failed to convert image to WebP'));
                }
              }, 'image/webp',
              // 0.8 // Quality (0.8 = 80% quality)
              1 // Quality (0.8 = 80% quality)
              );
            };

            img.onerror = function () {
              return reject(new Error('Failed to load image'));
            };
            img.src = URL.createObjectURL(file);
          });
        },
        imageUpload: function imageUpload(event, uid) {
          var updatePic = event[0];
          this.loadingStatus = true;
          this.loadingPicProgress = 0;
          var self = this;
          var d = new Date();
          var t = d.getTime();
          var uploadTask = __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].storage().ref('userContent/' + uid + '/images/' + t).put(updatePic);
          uploadTask.on('state_changed', function (snapshot) {
            var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
            // console.log('Upload is ' + progress + '% done');
            self.loadingPicProgress = progress;
          }, function (error) {
            console.log(error);
          }, function () {
            uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              self.loadingStatus = false;
              self.newSlinkSite.user = downloadURL;
              self.newSlinkSite.imagePath = downloadURL;
              self.loadingStatus = false;
            });
          });
        },
        cancelImageUpload: function cancelImageUpload(site, image) {
          if (site == 'Image') {
            this.imageDelete(window.decodeURIComponent(image));
          }
        },
        getLocation: function getLocation() {

          if (this.userDetails.ice && navigator.geolocation) {

            navigator.geolocation.watchPosition(this.showPosition, null, { enableHighAccuracy: true, maximumAge: 6000, timeout: 60000 });
          } else {
            console.log("Geolocation is not supported by this browser.");
          }
        },

        deletePage: function deletePage(uid, source) {
          var _this5 = this;

          var setType = db.ref('users/' + uid + '/delete');
          setType.transaction(function (current_value) {
            return true;
          });
          if (source == 'admin') {
            __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].auth().signOut().then(function () {
              _this5.$router.replace({ name: "Home" });
            });
          }
        },
        deletePageFromSuperadmin: function deletePageFromSuperadmin(uid, source) {
          var setType = db.ref('users/' + uid + '/delete');
          setType.transaction(function (current_value) {
            return true;
          });
        },
        showPosition: function showPosition(position) {
          this.iceLocation = position.coords.latitude + ', ' + position.coords.longitude;
          var locatedName = this.profile[0].name;
          var self = this;
          // let self = this

          this.fbdb = db.ref("users/" + this.profile[0]['.key'] + "/iceLocation");
          // console.log('db', this.fbdb.ref )
          this.fbdb.transaction(function (current_value) {
            // console.log('gtoggleProperty',property, !current_value)
            return { latitude: position.coords.latitude, longitude: position.coords.longitude, name: locatedName, contact: self.profile[0].iceContact };
          });

          // console.log('Position', this.iceLocation )
        },
        imageDelete: function imageDelete(image) {
          console.log(image);
          if (image.indexOf('firebase') != -1) {
            image = window.decodeURIComponent(image);
            var pathPattern = new RegExp(/userContent\/.*\/\d*/i);
            image = window.decodeURIComponent(pathPattern.exec(image));
            var deleteTask = __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].storage().ref(image).delete().then(function () {
              // File deleted successfully
            }).catch(function (error) {
              // Uh-oh, an error occurred!
            });
          } else {
            console.log('no standard image');
          }
        },
        scrollTo: function scrollTo(id) {
          var moveTo = document.querySelector(id).getBoundingClientRect();
          window.scrollTo(moveTo.left, moveTo.top + window.scrollY - 62);
        },

        mediaHeight: function mediaHeight(id, site, definedHeight) {
          if (site == 'YouTube Player' || site == 'Vimeo Player') {
            this.$nextTick(function () {
              document.getElementById(id).style.height = document.getElementById(id).clientWidth / 1.77 + 'px';
              document.getElementById(id).style.minHeight = null;
            });
            return;
          } else if (site == 'TikTok Player') {
            this.$nextTick(function () {
              // document.getElementById(id).style.height= (document.getElementById(id).clientWidth /1.77)+'px'
              document.getElementById(id).style['aspect-ratio'] = 9 / 16;
              // document.getElementById(id).style.minHeight= null
            });
            return;
          } else if (site == 'galleryThumb') {
            this.$nextTick(function () {
              // console.log(id, 'imagewidth:',document.getElementById(id).clientWidth)
              document.getElementById(id).style.height = document.getElementById(id).clientWidth + 'px';
            });
            return;
          } else {
            this.$nextTick(function () {
              try {
                var height = null;
                var res = definedHeight.match(/\bheight[=:"]*\d*/g);
                height = res[0].replace(/\bheight[=:"]*/g, '').concat('px');
                document.getElementById(id).style.height = height;
              } catch (e) {
                console.log('embed height error', e);
              }
            });
          }
        },
        listOrder: function listOrder(list) {
          return _.orderBy(list, "order");
        },
        imageApproved: function imageApproved(safeSearch) {
          if (safeSearch.adult === 'VERY_LIKELY' ||
          // safeSearch.spoof !== VERY_UNLIKELY ||
          // safeSearch.medical !== VERY_LIKELY ||
          safeSearch.violence === 'VERY_LIKELY' || safeSearch.racy === 'VERY_LIKELY') {
            return false;
          } else {
            return true;
          }
        },
        readMessages: function readMessages(uid) {
          this.fbdb = db.ref("users/" + uid + "/messages/unread");
          this.fbdb.transaction(function (current_value) {
            return false;
          });
          this.gGALog(this.userDetails.url, "Messages", "Read");
        },
        resetPageViews: function resetPageViews(uid) {
          this.fbdb = db.ref("users/" + uid + "/pageViews");
          this.fbdb.transaction(function (current_value) {
            return 0;
          });
        },
        resetCoins: function resetCoins(uid) {
          this.fbdb = db.ref("users/" + uid + "/slinkCoins");
          this.fbdb.transaction(function (current_value) {
            return null;
          });

          this.fbdb = db.ref("users/" + uid + "/coinStatement");
          this.fbdb.transaction(function (current_value) {
            return null;
          });
        },
        deleteChild: function deleteChild(uid) {
          db.ref("/users/" + uid).remove();
          db.ref("/url/" + uid).remove();
          this.showNotification("Page Deleted!");
        },
        webShare: function webShare() {
          if (navigator.share) {
            navigator.share({
              title: "Slink - Digital Business Card",
              text: "Check out " + this.userDetails.name + "'s social media and websites on their Slink Digital Business Card",
              url: 'https://MySlink.app/' + this.userDetails.url
            });
          } else {
            console.log("provide a fallback here");
          }
        },
        getSlinkCanInLine: function getSlinkCanInLine(site) {
          var x = this.slinkCanInLine.indexOf(site);
          if (x != -1) {
            return true;
          }
        },
        gGetMJid: function gGetMJid(email, uid) {
          console.log("gGetMJid", email, uid);
          var mData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            email: email,
            uid: uid
          });
          console.log(mData);
          fetch("https://751fb4c3267275903c75b95dc595d25f.m.pipedream.net", {
            cache: "no-cache",
            credentials: "same-origin",
            headers: { "user-agent": "Mozilla/4.0 MDN Example", 'Content-Type': 'application/json' },
            method: "POST",
            mode: "no-cors",
            redirect: "follow",
            referrer: "no-referrer",
            body: mData
          });
        },
        gGetFavicon: function gGetFavicon(domain) {
          var self = this;
          fetch("https://favicongrabber.com/api/grab/" + domain).then(function (response) {
            response.json().then(function (data) {
              self.gCustomSiteFavicon = data.icons[0].src;
              return self.gCustomSiteFavicon;
            });
          });
        },
        gTravel: function gTravel(base, details, suffix) {
          // console.log(base, details, suffix)
          this.travelTo = base + details.trim() + suffix;
          if (this.travelTo != "undefined" && base != 'QR Code') {
            if (this.travelTo.indexOf(":") == -1) {
              this.travelTo = "http://" + this.travelTo;
            }
            if (this.userDetails.warning != true) {
              if (this.travelTo.indexOf("mailto:") != -1 || this.travelTo.indexOf("tel:") != -1) {
                window.location.assign(this.travelTo);
              } else {
                window.open(this.travelTo);
              }
            }
          }
        },
        openExternal: function openExternal(url) {
          // console.log(base, details, suffix)
          // this.travelTo = base + details.trim() + suffix;
          // if (this.travelTo != "undefined"  && base != 'QR Code') {
          //   if (this.travelTo.indexOf(":") == -1) {
          //     this.travelTo = "http://" + this.travelTo;
          //   }
          //   if(this.userDetails.warning != true){
          //     if (
          //       (this.travelTo.indexOf("mailto:") != -1 ||
          //       this.travelTo.indexOf("tel:") != -1)
          //     ) {
          //       window.location.assign(this.travelTo);
          //     } else {
          // this.gGALog(this.userDetails.url, "External URL", url)
          // this.gFBALog('External URL', {'site':url, 'details':this.userDetails.url})
          window.open(url);
          //     }
          //   }
          // }
        },

        // editContent(evt){
        //   console.log('before',evt.target.innerText,'#')          
        // },
        updateProperty: function updateProperty(evt) {
          // console.log('after: #',evt.target.innerText,'#')
          var newContent = evt.target.innerText;
          db.ref("users/" + this.activeUID + "/" + evt.target.id).transaction(function (current_value) {
            // console.log('after: #', newContent,'#fb')
            return newContent;
          });
        },

        // gMailchimpTag(user, tag) { //redundant
        //   let mData = user + ":" + tag;
        //   fetch("../api/addTags", {
        //     cache: "no-cache",
        //     credentials: "same-origin",
        //     headers: { "user-agent": "Mozilla/4.0 MDN Example" },
        //     method: "POST",
        //     mode: "no-cors",
        //     redirect: "follow",
        //     referrer: "no-referrer",
        //     body: mData
        //   })
        //     .then(res => res.json())
        //     .then(json => console.log(json));
        // },
        gCreateCustomSite: function gCreateCustomSite(site, domain, favicon) {
          // console.log("gcreatecustomsite");
          this.customNewSite = this.gSiteTemplate;
          this.customNewSite.favicon = favicon;
          this.customNewSite.customsite = domain;
          this.customNewSite.site = domain.charAt(0).toUpperCase() + domain.slice(1);
          db.ref("customsite/").push(this.customNewSite);
          var createdSite = [];
          createdSite.push(this.customNewSite);
          return createdSite;
        },
        failedIcon: function failedIcon(event) {
          // console.log('failedIcon', event.target.id)
          event.target.style.width = "100%";
          event.target.style.height = "100%";
          event.target.style.objectFit = "contain";
          // event.target.src = 'https://ui-avatars.com/api/?bold=true&background=fff&color=000&length=1&size=128&name='+event.target.id
          event.target.src = "../static/images/favicons/initial/" + event.target.id.slice(0, 1).toLowerCase() + ".png";
          // event.target.style.marginLeft = "inherit";
          // event.target.style.marginRight = "inherit";
          // event.target.style.marginTop = "unset";
          event.target.style.margin = "8px auto";

          return "/static/images/favicons/link.png";
        },

        logout: function logout() {
          var _this6 = this;

          this.gGALog(this.userDetails.url, "Logout", "Logged Off");
          __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].auth().signOut().then(function () {
            _this6.$router.replace({ name: "Home" });
          });
        },
        gGALog: function gGALog(category, action, label, value, url) {
          this.$ga.event({
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value
          });
        },
        gFBALog: function gFBALog(event, params) {
          __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["a" /* analytics */].logEvent(event, params);
          // console.log('gFBALog', event, params)
        },

        fullColourButtons: function fullColourButtons(background, usage) {
          // console.log('fcb', background)

          var bg = background;
          if (background == undefined) {
            background = '#ffffff';
          }
          if (this.userDetails.fullColourButtons && background.indexOf("#") == 0 && (this.userDetails.account == 7 || this.userDetails.enableUpgrades)) {
            bg = background;
            // console.log('full colour', background)
          } else {
            bg = '#ffffff';
          }

          if (this.userDetails.backgroundImage) {
            console.log('has background image');
            bg = this.userDetails.buttonGlass == false ? bg : bg + 'BF';
            // bg= buttonGlass == false ? bg: bg + 'BF'
          }
          if (usage == 'socialShare') {
            // console.log('socialShareColour', background)
            bg = background;
          }
          return bg;
          // return this.userDetails.fullColourButtons && background.indexOf("#") == 0 && (this.userDetails.account == 7 || this.userDetails.enableUpgrades)
          //   ? background
          //   : "#ffffff";
        },
        fullColourButtonsText: function fullColourButtonsText(background, ForceTextColour, color, usage) {
          // if(background == undefined && usage == 'footer'){
          //   background = '#000000'
          //   console.log('fcbt', background, usage)
          // }
          // console.log(event)
          if (background == undefined || background == 'white') {
            background = '#ffffff';
          }
          if (ForceTextColour) {
            return color;
          } else if ((this.userDetails.fullColourButtons || usage == 'colorPicker') && (this.userDetails.account == 7 || this.userDetails.enableUpgrades || usage == 'socialShare' || usage == 'colorPicker') || usage == 'footer' || usage == 'slinkcarddemo') {
            var r = parseInt(background.substr(1, 2), 16); // Grab the hex representation of red (chars 1-2) and convert to decimal (base 10).
            var g = parseInt(background.substr(3, 2), 16);
            var b = parseInt(background.substr(5, 2), 16);

            // r /= 255, g /= 255, b /= 255;
            // var max = Math.max(r, g, b), min = Math.min(r, g, b);
            // var l = (max + min) / 2;
            // var h, s, l = (max + min) / 2;

            // if(max == min){
            //     h = s = 0; // achromatic
            // }else{
            //     var d = max - min;
            //     s = l > 0.51 ? d / (2 - max - min) : d / (max + min);
            //     switch(max){
            //         case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            //         case g: h = (b - r) / d + 2; break;
            //         case b: h = (r - g) / d + 4; break;
            //     }
            //     h /= 6;
            // }
            // var c = Math.round((l -1)) *-100
            // var text = "hsl(0,0%,"+c+"%)"
            // console.log('text color:',"hsl(0,0%,"+ (Math.round((l -1)) *-100)+"%)", r,g,b, l)
            // console.log('text colour', background, "hsl(0,0%,"+ (Math.round((l -1)) *-100)+"%)")
            // return "hsl(0,0%,"+ (Math.round((l -1)) *-100)+"%)"
            var yiq = (r * 299 + g * 587 + b * 114) / 1000;
            return yiq >= 128 ? '#000000' : '#ffffff';
            // r /= 255, g /= 255, b /= 255;
            // var max = Math.max(r, g, b), min = Math.min(r, g, b);
            // var l = (max + min) / 2;
            // return "hsl(0,0%,"+ (Math.round((l -1)) *-100)+"%)"
          } else {
            return '#000000';
          }

          // return this.userDetails.fullColourButtons &&
          //   background.indexOf("#") == 0
          //   ? "#ffffff"
          //   : "#000000";
        },
        // showQuicklink: function(state) { //redundant
        //   return (this.userDetails.quicklink == true && state == true) ? false : true;
        // },
        // gFetchRSS() {
        // this.gGALog('test', 'test','test',null,'test')
        // let feed = []
        // console.log('fetching rss')
        // let x =  fetch('https://cors-anywhere.herokuapp.com/https://www.youtube.com/feeds/videos.xml?channel_id=UCP4bf6IHJJQehibu6ai__cg').then(
        //    function(response) {
        //        console.log(response)
        //        response.json().then(function(data) {
        //         console.log(data);
        //       });
        //    }
        //  )
        // console.log(this.gUserDetails.url);
        // },
        // gUpdateMailchimpID: function(uid, email) {
        //   let self = this;
        // fetch("https://helloacm.com/api/md5/?s=" + email).then(function(
        //   response
        // ) {
        //   response.json().then(function(data) {
        //     console.log("md5", email, data);
        //     db.ref("users/" + uid).update({ mailchimpID: data });
        //   });
        // });
        // },
        gtoggleProperty: function gtoggleProperty(property, uid, profileKey, url) {
          db.ref("users/" + uid + "/" + property).transaction(function (current_value) {
            return !current_value;
          });
          this.gGALog(url, "Profile updated", property);
        },
        gUpdateProperty: function gUpdateProperty(property, value, uid, profileKey, url) {
          this.fbdb = db.ref("users/" + uid + "/" + property);
          this.fbdb.transaction(function (current_value) {
            return value;
          });
          this.gGALog(url, "Profile updated", property);
        },
        pushSlink: function pushSlink(uid, url, site) {
          delete site['.key'];
          this.fbdb = db.ref("users/" + uid + "/links/").push(site);
          this.showNotification("Slink Added!");
          this.gaLog(url + " (Admin)", "Add Slink", site.site);
        },

        // gUpdateSlink(uid, link, properties) {      // redundant
        //   this.fbdb = db.ref("users/" + uid + "links/" + link);
        //   this.fbdb.transaction(function(current_value) {
        //   });
        // },
        showNotification: function showNotification(message) {
          this.notification = message;
          this.$refs.snackbar.open();
        },
        showUpgradeNotification: function showUpgradeNotification(message) {
          this.notification = message;
          this.$refs.upgradesnackbar.open();
          // console.log("upgrade notification");
        },
        gDeleteSlink: function gDeleteSlink(uid, key, link, url) {
          this.fbdb = db.ref("users/" + uid + "/links/" + key).remove().then(function () {
            // console.log("Remove succeeded.")
            // traverse slink array to fi
          }).catch(function (error) {
            console.log("Remove failed: " + error.message);
          });
          this.gGALog(url, "Deleted Slink", link);
          this.showNotification("Slink Deleted!");
        },

        // gDisableSlink: function(uid, key) {
        //   this.fbdb = db.ref("users/" + uid + "/links/" + key + "/disabled");
        //   this.fbdb.transaction(function(current_value) {
        //     return !current_value;
        //   });
        // },
        gLinkProperties: function gLinkProperties(uid, key, property) {
          this.fbdb = db.ref("users/" + uid + "/links/" + key + "/" + property + "/");
          this.fbdb.transaction(function (current_value) {
            return !current_value;
          });
        },
        gCreateNewUser: function gCreateNewUser(uid, user) {
          // console.log("gCreateNewUser");
          var newUID = uid + "_" + user.toLowerCase();
          var url = user.replace(/\s/g, "").toLowerCase();

          if (user != null) {
            this.fbdb = db.ref("users/" + newUID + "/profile/").push({
              name: user,
              //   name: user.toLowerCase(),
              picture: "https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/Profile%20Pictures%2Fdefaultprofilepic.jpg?alt=media&token=ae91f354-bb14-490a-9577-fa3aff108a23",
              url: url,
              account: 0,
              onboarding: false
            });
            this.fbdb = db.ref("users/" + newUID).update({ url: url }); //.then(_ => console.log("url updated in userlinks"));
            this.fbdb = db.ref("url/" + newUID).update({ url: url });
            // this.slack(uid, email)
            // this.showNotification('New user '+ user + ' created!')
          } else {
              //   this.showNotification('New user name was empty!')
            }
          return newUID;
        },
        gCreateNewPage: function gCreateNewPage(page, parentProfileKey) {
          // console.log("gCreateNewPage", page);
          var newUID = page.parent + "_" + page.url;
          page.url = page.url + Math.random().toString(36).substring(4, 8);

          // page.url = this.gURLExists(page.url)
          // console.log('output', this.gURLExists(page.url))
          // if (this.gURLExists(page.url)){
          //     page.url = page.url + '_' +page.parent.substring(0, 4).toLowerCase()
          // }
          // console.log('creating:', newUID, page.name, page.url)

          this.fbdb = db.ref("users/" + newUID + "/profile/").push(page);
          this.fbdb = db.ref("users/" + newUID).update({ url: page.url }); //.then(_ => console.log("url updated in userlinks"));
          this.fbdb = db.ref("url/" + newUID).update({ url: page.url });

          var nc = {};
          nc[newUID] = page.name;
          this.fbdb = db.ref("users/" + this.parentUID + "/profile/" + parentProfileKey + "/children").update(nc);
          return newUID;
        },

        gURLExists: function gURLExists(url) {
          var _this7 = this;

          // console.log("checking for:", "#" + url + "#");
          var exists = false;
          var u = null;
          var self = this;

          if (this._urlExists == undefined) {
            // console.log("prefetch, _urlExists is undefined");

            this.$bindAsArray("_urlExists", db.ref("url/").orderByChild("url").equalTo(url.toLowerCase()), null, function () {
              _this7.$bindAsArray("_urlExists", db.ref("url/").orderByChild("url").equalTo(url.toLowerCase()), null, function () {
                for (var i in _this7._urlExists) {
                  // console.log(this._urlExists[i].url);
                  exists = true;
                }
              });
            });
          } else {
            this.$bindAsArray("_urlExists", db.ref("url/").orderByChild("url").equalTo(url.toLowerCase()), null, function () {
              // console.log('#1', 'length',this._urlExists, this._urlExists.length)
              // console.log('#2', 'length',self._urlExists, self._urlExists.length)
              //    console.log('###', result)
              for (var i in _this7._urlExists) {
                // console.log(this._urlExists[i].url);
                self.urlExists = true;
                exists = true;

                // return true
                // exists = true
                // return exists
                // if(i != '.key' && i != '.value' ){
                //     u = this._urlExists[i].url
                //     exists = true
                //     return true
                // }
              }
              // if(this._urlExists.length == 1){
              //     exists = true
              //     return true
              // }
              // else{
              //     console.log('pooh')
              // }
              // this.$unbind('_urlExists')
              // return exists
            });
          }

          // this.$unbind('_urlExists')
          // console.log('URL:',url, 'exists:', exists, this._urlExists.length)
          // console.log('u', u)

          // return this.urlExists
          return exists;
        },
        // copyDetails: function(toCopy) {

        //   this.$clipboard(toCopy);
        //   this.showNotification("Copied to Clipboard");
        // },
        copy: function copy(toCopy) {
          this.$clipboard(toCopy);
          this.showNotification("Copied to Clipboard");
        },
        gGetAccountFeatures: function gGetAccountFeatures(account) {
          var features = [];
          if (account == 0) {
            features.description = "Free account: Unlimited links can be added to your Slink page. Custom labels are enabled. Custom descriptions are not enabled.";
            features.type = "Slink Free";
            features.customDescription = false;
          }
          // Not Assigned
          if (account == 1) {
            features.description = "";
            features.type = "";
            features.customDescription = false;
          }
          // // Not Assigned
          if (account == 2) {
            features.description = "";
            features.type = "";
            features.customDescription = false;
          }
          // Not Assigned
          if (account == 3) {
            features.description = "";
            features.type = "";
            features.customDescription = false;
          }
          // Not Assigned
          if (account == 4) {
            features.description = "";
            features.type = "";
            features.customDescription = false;
          }
          // Early Adopters Alpha - low impact
          if (account == 5) {
            features.description = "Slink Free Upgrade";
            features.type = "Slink Free Upgrade";
            // features.limit = 20;
            features.customDescription = true;
            // features.footer = true;
          }
          if (account == 6) {
            features.description = "Slink Plus";
            features.type = "Slink Plus";
            features.customDescription = true;
          }
          if (account == 7) {
            features.description = "Slink Premium";
            features.type = "Slink Premium";
            features.customDescription = true;
          }
          if (account == 8) {
            features.description = "Slink Enterprise";
            features.type = "Slink Enterprise";
            features.customDescription = true;
          }
          return features;
        }
      }
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (SlinkPlugins);

/***/ }),

/***/ "89vL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return analytics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__("dih4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database__ = __webpack_require__("hZls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire__ = __webpack_require__("1mcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuefire__);

// 'firebase/compat/app'


// import "firebase/remote-config";
// import { getRemoteConfig } from "firebase/remote-config";

// const remoteConfig = getRemoteConfig();
// import 'firebase/storage'
// import 'firebase/compat/messaging'
// import { getMessaging } from "firebase/messaging";

// const messaging = getMessaging();
// import 'firebase/firestore';


// let app;
var firebaseConfig = {
  apiKey: "AIzaSyCZ9ZOb7jXUirpySnyET8CTLcXcH1zsDmI",
  authDomain: "slink-64a53.firebaseapp.com",
  databaseURL: "https://slink-64a53.firebaseio.com",
  projectId: "slink-64a53",
  storageBucket: "slink-64a53.appspot.com",
  messagingSenderId: "490970029935",
  appId: "1:490970029935:web:6ec47cc7e30bd144",
  measurementId: "G-GK4715EJD7"
};
var fb = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(firebaseConfig);
var analytics = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.analytics();
// export const snfb = Firebase.firestore();
// export const messaging = Firebase.messaging();
// console.log('firebase initialised from firebaseconfig.js')

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32fe84a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("mmDE");
function injectStyle (ssrContext) {
  __webpack_require__("ZLxX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32fe84a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__registerServiceWorker__ = __webpack_require__("29pa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material__ = __webpack_require__("Lgyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__ = __webpack_require__("tzNG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire__ = __webpack_require__("1mcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_clipboard__ = __webpack_require__("DOD7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_v_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_plugins_js__ = __webpack_require__("6NMK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_numeral_filter__ = __webpack_require__("gu9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_font_picker_vue__ = __webpack_require__("vm4N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_font_picker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_font_picker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__registerServiceWorker__ = __webpack_require__("29pa");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









// import { orderby } from 'lodash'
// import orderBy from 'lodash.orderby'





// import linkinfo from './components/linkinfo_component'
// import Vue from 'vue'

// import vCardsJS from 'vcards-js'
// import draggable from 'vuedraggable'




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_v_clipboard___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__components_plugins_js__["a" /* default */]);
// Vue.use(linkinfo)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_numeral_filter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_font_picker_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_analytics___default.a, {
  // id: ['UA-81938309-3'],
  id: ['UA-81938309-3'], beforeFirstHit: function beforeFirstHit() {
    // this is right after the tracker and before every other hit to Google Analytics
    // console.log('ga beforefirsthit -main')
  },
  ready: function ready() {
    // console.log('ga ready -main')
    // here Google Analytics is ready to track!
  },

  // checkDuplicatedScript: true,
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */]
});

var app = void 0;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_12__App__["default"] },
  mounted: function mounted() {
    this.$material.inkRipple = false;
    // this.checkInAppBrowser();
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_firebaseconfig__ = __webpack_require__("89vL");






var db = __WEBPACK_IMPORTED_MODULE_4__components_firebaseconfig__["b" /* fb */].database();

var Home = function Home() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "wUZA"));
};
// const HomeBeta = () => import('@/components/homebeta')
var SlinkView = function SlinkView() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "RB1u"));
};
// const SlinkLiveView = () => import('@/components/slinkliveview')
var Admin = function Admin() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "sRWR"));
};
// const AdminDev = () => import('@/components/admindev')
var EnterpriseAdmin = function EnterpriseAdmin() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "hMjO"));
};
var SuperAdmin = function SuperAdmin() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "ebDf"));
};
var SuperAdminDev = function SuperAdminDev() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "tEYm"));
};
var SuperAdminLinks = function SuperAdminLinks() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "laFM"));
};
var SuperAdminAdverts = function SuperAdminAdverts() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "Mpm1"));
};
var SuperAdminTools = function SuperAdminTools() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "2iRy"));
};
var gos = function gos() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "xofJ"));
};
var wyr = function wyr() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "T7Gq"));
};
// const bos = () => import('@/components/bos')
// const Gallery = () => import('@/components/gallery')
// const Billing = () => import('@/components/billing')
// const Card = () => import('@/components/card')
// const Rewards = () => import('@/components/coins')
// const MyFSP = () => import('@/components/myfsp')
var NotFound = function NotFound() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "thLP"));
};
var TicketValidator = function TicketValidator() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "9vcd"));
};
var ScratchCardChecker = function ScratchCardChecker() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "kOTo"));
};
var AdminTools = function AdminTools() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "a0Kt"));
};
var WyrAdminStats = function WyrAdminStats() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "voBu"));
};
var AdminAccounts = function AdminAccounts() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "x4xp"));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_meta___default.a);

// export default new Router({
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  watch: {
    $route: function $route(to) {
      //  document.title = `APPLICATION_NAME - ${to.meta.title}`;
      var link = document.querySelector("[rel='icon']");
      link.setAttribute('href', to.meta.icon);
    }
  },
  routes: [{
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/girlsofslink/:url?',
    name: 'Girls of Slink',
    component: gos,
    meta: {
      requiresAuth: false
      // title: "Girls of Slink",
    },
    alias: ['/gos', '/girlsofslink', '/bos', '/boysofslink']
  }, {
    path: '/wouldyourather/:url?',
    name: 'Would You Rather?',
    component: wyr,
    meta: {
      requiresAuth: false
      // title: "Girls of Slink",
    },
    alias: ['/wyr']
  }, {
    path: '/wouldyourather/:url?/:uid?',
    name: 'Would You Rather?',
    component: wyr,
    meta: {
      requiresAuth: false
      // title: "Girls of Slink",
    },
    alias: ['/wyr']
  }, {
    path: '/wouldyourather/:url?/player/:playerUrl',
    name: 'Would You Rather Player',
    component: wyr,
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/justjeet',
    redirect: { name: 'Would You Rather?', params: { url: 'justjeet' } }
  },
  // {
  //   path: '/boysofslink/:url?',
  //   name: 'Boys of Slink',
  //   component: bos,
  //   meta: {
  //       requiresAuth: false,
  //       // title: "Girls of Slink",
  //   },
  //   alias: ['/bos', '/boysofslink']
  // },
  {
    path: '/affiliate/:affiliatecode',
    name: 'SlinkViewAffiliate',
    component: Home,
    props: true
  },
  // {
  //   path: '/homebeta',
  //   name: 'Home Beta',
  //   component: HomeBeta
  // },
  {
    path: '/notfound',
    name: 'Page Not Found',
    component: NotFound,
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/ticketvalidator',
    name: 'Ticket Validator',
    component: TicketValidator,
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/scratchcardvalidator',
    name: 'Scratchcard Validator',
    component: TicketValidator,
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/scratchcardchecker',
    name: 'Scratchcard Checker',
    component: ScratchCardChecker,
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      requiresAuth: true
    }
  },
  // {
  //   path: '/admin/rewards',
  //   name: 'Rewards',
  //   component: Rewards,
  //   meta: {
  //       requiresAuth: true
  //   },
  //   props: true
  // },
  // {
  //   path: '/admin/myfsp',
  //   name: 'Featured Slink Pages',
  //   component: MyFSP,
  //   meta: {
  //       requiresAuth: true
  //   },
  //   props: true
  // },
  // {
  //   path: '/admin/:uid',
  //   name: 'Admin',
  //   component: Admin,
  //   meta: {
  //       requiresAuth: true
  //   }
  // },
  // {
  //   path: '/admindev',
  //   name: 'AdminDev',
  //   component: AdminDev,
  //   meta: {
  //       requiresAuth: true
  //   }
  // },
  {
    path: '/enterprise',
    name: 'Enterprise Admin',
    component: EnterpriseAdmin,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/superadmin',
    name: 'Super Admin',
    component: SuperAdmin,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/superadmindev',
    name: 'Super Admin Dev',
    component: SuperAdminDev,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/superadmin/links',
    name: 'Super Admin Links',
    component: SuperAdminLinks,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/superadmin/adverts',
    name: 'Super Admin Adverts',
    component: SuperAdminAdverts,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/superadmin/tools',
    name: 'Super Admin Tools',
    component: SuperAdminTools,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/superadmin/accounts',
    name: 'Admin Accounts',
    component: AdminAccounts,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/admin/tools/:secret',
    name: 'Admin Tools',
    component: AdminTools,
    meta: {
      requiresAuth: true
    },
    beforeEnter: function beforeEnter(to, from, next) {
      // Basic protection - replace with proper authentication
      if (to.params.secret === 'update_wyr_urls') {
        next();
      } else {
        next('/admin');
      }
    }
  }, {
    path: '/admin/wyr-stats/:secret',
    name: 'WYR Admin Stats',
    component: WyrAdminStats,
    meta: {
      requiresAuth: true
    },
    beforeEnter: function beforeEnter(to, from, next) {
      // Basic protection - replace with proper authentication
      if (to.params.secret === 'stats_dashboard') {
        next();
      } else {
        next('/admin');
      }
    }
  },
  // {
  //   path: '/gallery/:filter',
  //   name: 'Gallery',
  //   component: Gallery,
  //   props: true
  // }, 
  // {
  //   path: '/coins',
  //   name: 'Coins',
  //   component: Coins,
  //   meta: {
  //     requiresAuth: true
  //   },
  //   props: true
  // }, 
  // {
  //   path: '/billing/:state?',
  //   name: 'Billing',
  //   component: Billing,
  //   meta: {
  //     requiresAuth: true
  //   },
  //   props: true
  // }, 
  // {
  //   path: '/card/:state?',
  //   name: 'Card-Shop',
  //   component: Card,
  //   meta: {
  //     requiresAuth: true
  //   },
  //   props: true
  // }, 
  // {
  //   path: '/c/:uid',
  //   name: 'Card',
  // },
  // {
  //   path: '/:uid/photo',

  //   beforeEnter: (to, from) => {
  //     console.log('photo', document.referrer)
  //     // location.href = 'https://us-central1-slink-64a53.cloudfunctions.net/profilephoto/' + to.params.uid
  //     window.location.replace('https://us-central1-slink-64a53.cloudfunctions.net/profilephoto/' + to.params.uid)
  //   }

  // },
  {
    path: '/:uid/ticket/:ticket',
    name: 'SlinkViewTicket',
    component: SlinkView,
    props: true
  },

  // {
  //   // LIVE SLINKVIEW
  //   path: '/live/:uid/:hop?',
  //   name: 'SlinkLiveView',
  //   component: SlinkView,
  //   meta:{
  //     // 'icon':"https://us-central1-slink-64a53.cloudfunctions.net/profilePicture/goubtube"
  //   }, 
  //   props: true
  // },
  {
    // GENERAL SLINKVIEW
    path: '/:uid/location/:loc',
    name: 'CineMapper Location',
    component: SlinkView,
    meta: {},
    props: true
  }, {
    // GENERAL SLINKVIEW
    path: '/:uid/category/:cat',
    name: 'CineMapper Category',
    component: SlinkView,
    meta: {},
    props: true
  },
  // {
  //   // GENERAL SLINKVIEW
  //   path: '/:uid/search/:search',
  //   name: 'CineMapper Search',
  //   component: SlinkView,
  //   meta:{
  //   }, 
  //   props: true
  // },
  // {
  //   // GENERAL SLINKVIEW
  //   path: '/:uid/admin',
  //   name: 'SlinkView',
  //   component: SlinkView,
  //   meta:{
  //   }, 
  //   props: true
  // },

  {
    // GENERAL SLINKVIEW
    path: '/:uid/:hop?',
    name: 'SlinkView',
    component: SlinkView,
    meta: {
      // 'icon':"https://us-central1-slink-64a53.cloudfunctions.net/profilePicture/goubtube"
    },
    props: true
  }, {
    // GENERAL SLINKVIEW
    path: '/:uid/player/:user',
    name: 'Scratch and Win SlinkView',
    component: SlinkView,
    meta: {},
    props: true
  }],
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  // console.log('router', from, to)
  // if(to.name == 'Card'){


  // db.ref('cards/'+ to.params.uid).once('value').then(function(snapshot) {
  //   if(snapshot.val()){
  //     db.ref('users/'+ snapshot.val().uid).once('value').then(function(urlSnapshot) {
  //       next({
  //         name: 'SlinkView',
  //         params: {
  //           uid: urlSnapshot.val().url,
  //           card: true,
  //         }
  //       })
  //     });
  //   }
  //   else{
  //     next({
  //       name: 'Home',
  //     })
  //   }
  // });


  //   db.ref('url').orderByChild('card').equalTo(to.params.uid).limitToFirst(1).once('value').then(snapshot => {
  //   // console.log('query run' )
  //   const user = snapshot.val()
  //   if(user != null){
  //     for(var i in user){
  //       console.log()
  //         // next({
  //         //   name: 'SlinkView',
  //         //   params: {
  //         //     uid: user[i].url,
  //         //     card: true
  //         //   }
  //         // })
  //     }
  //   }
  //   else{
  //     next({
  //       name: 'Home',
  //     })
  //   }
  // })
  // }
  if (to.name == 'Home') {
    // else if(to.name == 'Home'){
    __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (user) next({ name: 'Admin' });
    });
  } else {
    // console.log('router to', to)
  }
  if (to.params.uid === 'cinemapper') {
    document.title = "CineMapper";
    var favicon = document.getElementById("shortcut icon");
    favicon.href = "https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F-NaBwc3brLvzF2VsHzIm%2Fmarkers%2Fdefault.png?alt=media&token=fcb2d86a-3470-447a-9a47-1bdfdb187985";
  }
  if (to.name === 'Girls of Slink') {
    document.title = "Girls of Slink";
    // const favicon = document.getElementById("shortcut icon");
    // favicon.href = "https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F-NaBwc3brLvzF2VsHzIm%2Fmarkers%2Fdefault.png?alt=media&token=fcb2d86a-3470-447a-9a47-1bdfdb187985";
  }
  if (to.name === 'Would You Rather?') {
    document.title = "Would You Rather by Slink";
  }
  // else if(to.name == 'SlinkView'){
  // console.log('going to slinkview')
  // const favicon = document.getElementById("shortcut icon");
  // console.log('favicon', favicon)
  // favicon.href = "https://us-central1-slink-64a53.cloudfunctions.net/profilePicture/"+to.params.uid;
  // }
  __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().onAuthStateChanged(function (user) {
    var requiresAuth = to.matched.some(function (record) {
      return record.meta.requiresAuth;
    });
    if (requiresAuth && !user) next({ name: 'Home' });else next();
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ZLxX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mmDE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tzNG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, exports) {

//
//
//
//
//
//

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6c0951b7e4034ddb319e.js